import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ACTButton from "./ACTButton";
import Timer from "../Timer";
import { AppSelectDropdownWhite } from "./AppSelectDropdownWhite";
import AccountSelectInputWhite from "./AccountSelectInputWhite";
import { AppContext } from "../context/AppContext";

const USERS = [
  { label: "Demo",  email: "demo@fantastic.tech" },
  { label: "Kerry",  email: "kerry@advancedcompliance.tech" },
  { label: "Graeme", email: "graeme@advancedcompliance.tech" },
  { label: "Mike",   email: "mike@advancedcompliance.tech" },
  { label: "Miguel", email: "miguel@advancedcompliance.tech" },
];

const JURISDICTIONS_API = `${process.env.REACT_APP_JURISDICTIONS_API_BASE_URL}?emailId=`;

const HomePanel = (props) => {
  const { onGenerateQR, sessionData, deeplink, defaultAPIKey, onAccountIdChange } = props;
  const { setSelectedAPIKey } = useContext(AppContext);
  const timerRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [updateQrCode, setUpdateQrCode] = useState(false);
  const [accountIdEntered, setAccountIdEntered] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [jurisdictions, setJurisdictions] = useState([]);
  const [loadingJurisdictions, setLoadingJurisdictions] = useState(false);

  const onTextEnter = (text) => {
    setAccountIdEntered(text);
    if (onAccountIdChange) onAccountIdChange(text);
  };

  const handleUserChange = (event) => {
    const email = event.target.value;
    setSelectedUser(email);
    setJurisdictions([]);
    setSelectedAPIKey(null);
    setLoadingJurisdictions(true);

    fetch(`${JURISDICTIONS_API}${encodeURIComponent(email)}`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) setJurisdictions(data);
      })
      .catch((err) => console.error("[HomePanel] Failed to fetch jurisdictions:", err))
      .finally(() => setLoadingJurisdictions(false));
  };

  var expTime = sessionData?.expiryTime;

  useEffect(() => {}, []);

  const verifyLocation = () => {};

  const handleQrCodeScanned = () => {
    if (timerRef.current) {
      timerRef.current.stopTimer(); // Stop the timer
    }
  };
  const handleTimerExpire = () => {
    setUpdateQrCode(true);
  };

  const onRefreshQrCode = () => {
    onGenerateQR(accountIdEntered);
    setUpdateQrCode(false);
  };

  const openInVerifyApp = () => {
    window.location.href = deeplink;
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessionData?.qrCode) {
      setLoading(true);
    }
  }, [sessionData?.qrCode]);

  return (
    <>
      <Box
        sx={{
          marginTop: "4.5rem",
          width: "100%",
        }}
      >

        {!updateQrCode && (
          <>
            <Box
              sx={{
                backgroundColor: "#000000",
                height: "3.5rem",
                width: isMobile ? "90vw" : "26rem",
                padding: "0.5rem 0.75rem",
                borderRadius: "0.5rem",
                gap: "0.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              {/* User dropdown */}
              <FormControl
                variant="standard"
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root:before": { borderBottom: "1px solid #ffffff" },
                  "& .MuiInputBase-root:hover:not(.Mui-disabled):before": { borderBottom: "1px solid #ffffff" },
                  "& .MuiInputBase-root:after": { borderBottom: "none" },
                }}
              >
                <InputLabel
                  id="user-label"
                  sx={{ color: "white", "&.Mui-focused": { color: "#ffffff" } }}
                >
                  Select User
                </InputLabel>
                <Select
                  labelId="user-label"
                  value={selectedUser}
                  onChange={handleUserChange}
                  sx={{
                    color: "#ffffff",
                    ".MuiSelect-icon": { color: "#ffffff" },
                    "& .MuiInputBase-input": { color: "#ffffff" },
                  }}
                  MenuProps={{ PaperProps: { sx: { backgroundColor: "black", color: "#ffffff" } } }}
                >
                  {USERS.map((u) => (
                    <MenuItem key={u.email} value={u.email}>{u.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Jurisdiction dropdown — disabled until user selected and jurisdictions loaded */}
              <AppSelectDropdownWhite
                apps={jurisdictions}
                disabled={!selectedUser || loadingJurisdictions}
              />

              <AccountSelectInputWhite textHandler={onTextEnter} />
            </Box>
            {!sessionData?.qrCode ? (
              <Typography
                sx={{
                  maxWidth: "95%",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  lineHeight: "1.5",
                }}
              >
                {!selectedUser
                  ? <>Select a <span style={{ color: "#E54F9C" }}>user</span> to start</>
                  : loadingJurisdictions
                  ? <CircularProgress size="1.5rem" sx={{ color: "#E54F9C" }} />
                  : <>Select a <span style={{ color: "#E54F9C" }}>location</span> to continue</>
                }
              </Typography>
            ) : (
              <>
                {loading && (
                  <Box
                    sx={{
                      height: isMobile ? "125px" : "155px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "9rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    <CircularProgress
                      size="6rem"
                      sx={{
                        color: "#E54F9C",
                      }}
                    />
                  </Box>
                )}
                <img
                  src={sessionData?.qrCode}
                  alt="QR Code"
                  onLoad={() => setLoading(false)}
                  style={{
                    display: loading ? "none" : "flex",
                    width: isMobile ? "125px" : "155px",
                    height: isMobile ? "125px" : "155px",
                    margin: "0 auto",
                    position: "absolute",
                    top: "9rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                />
                <Typography
                  sx={{
                    maxWidth: "95%",
                    fontSize: "0.8rem",
                    fontWeight: "500",
                    lineHeight: "1.25",
                    margin: isMobile
                      ? "0.25rem auto 1rem auto"
                      : "0.25rem auto 0 auto",
                    width: "100%",
                    position: "absolute",
                    top: isMobile ? "21rem" : "19.25rem",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  Scan the QR code using the ACTVerify app.
                </Typography>

                {isMobile && (
                  <Box
                    sx={{
                      width: "17rem",
                      margin: isMobile
                        ? "0.75rem auto 0 auto"
                        : "1.5rem auto 0 auto",
                      position: "absolute",
                      top: "16.75rem",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    <ACTButton
                      content="Open in ACTVerify App"
                      onClick={openInVerifyApp}
                      bgColor="#E54F9C"
                      textColor="#ffffff"
                      hoverColor="#b33b78"
                      hoverTextColor="#ffffff"
                      border="0.1rem solid #E54F9C"
                      hoverBorder="0.1rem solid #b33b78"
                    />
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </Box>
      <Box>
        {sessionData?.expiryTime && (
          <Timer
            style={{
              maxWidth: "12.5rem",
              fontSize: "0.9rem",
              fontWeight: "500",
              margin: isMobile ? "0 auto" : "0.25rem auto",
            }}
            ref={timerRef}
            expiryTime={expTime}
            onExpire={handleTimerExpire}
          />
        )}

        {updateQrCode && (
          <Box
            sx={{
              width: "16rem",
              margin: "0 auto",
              position: "absolute",
              top: "10rem",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <ACTButton
              content="Refresh QR Code"
              onClick={onRefreshQrCode}
              bgColor="#E54F9C"
              textColor="#ffffff"
              hoverColor="#b33b78"
              hoverTextColor="#ffffff"
              border="0.1rem solid #E54F9C"
              hoverBorder="0.1rem solid #b33b78"
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default HomePanel;
